import user from "@/http/requests/Users"

export default {
    async getAllUsers(context)
    {
        try
        {
            let response = await user.getAllUsers();
            context.commit('setUsers', { users: response })
        } catch (Exception) {
            console.log(Exception)
            context.commit('setUsers', {users: []})
        }
    },
    async deleteUser(context, {id, token})
    {
        try{
            await user.deleteUser(id, token);
        }
        catch(Exception)
        {
            console.log(Exception);
        }
    },
    async alterUser(context, {id, token, alterObject})
    {
        try{
            await user.alterUser(id, token, alterObject);
        }catch(Exception)
        {
            console.log(Exception);
        }
    },
    async addUser(context, {token, data})
    {
        try {
            await user.addUser(token, data);
        } catch(Exception) {
            throw Exception;
        }
    },
    async alterUserEmail(context, {id, token, email})
    {
        try{
            await user.alterUserEmail(id, token, email);
        }catch(Exception)
        {
            console.log(Exception);
        }
    },
    async alterUserName(context, {id, token, name})
    {
        try{
            await user.alterUserName(id, token, name);
        }catch(Exception)
        {
            console.log(Exception);
        }
    },
    async alterUserUnblock(context, {id, token, alterObject})
    {
        try{
            await user.alterUserUnblock(id, token, alterObject);
        }catch(Exception)
        {
            console.log(Exception);
        }
    },
    async activityTwoFactor(context, {id, token, alterObject})
    {
        return new Promise ((resolve, reject) => {
            user.activityTwoFactor(id, token, alterObject).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    isFuncionalUser(_, token) {
        return new Promise((resolve, reject) => {
            user.isFuncionalUser(token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
}